import { render, staticRenderFns } from "./QuotesList.vue?vue&type=template&id=2f63ff06&"
import script from "./QuotesList.vue?vue&type=script&lang=js&"
export * from "./QuotesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports